var customSettings = {
    max: {
        xs: 2,
        sm: 3,
        md: 4,
        lg: 4,
        xl: 4
    }
};

jQuery.extend( e4.settings.search.result.products, customSettings );

if ( jQuery( '.e-header' ).find( '.e-nav-local-horizontal' ).length ) {
    jQuery( '#js-e-canvas' ).addClass( ' specific-canvas ' );
}

var specific = {};
jQuery( function () {
    specific.header.init();
    if ( jQuery( '.e-products' ).length > 0 ) {
        specific.productlist.init();
    }
    specific.popupBox.init();
    specific.sharePage.init();
    specific.disclaimerPopup.init();
    specific.productSelector.init();
} );

specific.productSelector = {
    init: function () {
        specific.productSelector.addChosenLinkToNextBtn();
        specific.productSelector.toggleLabelClass();
    },
    addChosenLinkToNextBtn: function () {
        jQuery( '.js-specific-answers' ).find( 'input' ).on( 'change', function () {
            var strValue = jQuery( this ).val();
            jQuery( '.js-specific-btn-next' ).attr( 'href', strValue ).removeClass( 'specific-disabled' );
        } );
    },
    toggleLabelClass: function () {
        jQuery( '.js-specific-answers' ).find( 'input' ).on( 'change', function () {
            jQuery( this ).siblings( 'label' ).addClass( 'checked' );
            jQuery( this ).closest( '.js-specific-answers' ).siblings().find( 'label' ).removeClass( 'checked' );
        } );
    }
};

specific.header = {
    isRAF: false,
    init: function () {
        specific.header.fit();
        specific.header.bindEvents();
    },
    bindEvents: function () {
        jQuery( window ).on( 'load resize', function () {
            if ( specific.header.isRAF === false ) {
                window.requestAnimationFrame( function () {
                    specific.header.fit();
                    specific.header.isRAF = false;
                } );
                specific.header.isRAF = true;
            }
        } );
    },
    fit: function () {
        var jHeader = jQuery( '.js-e-header' ),
            jCanvas = jQuery( '#js-e-canvas' );

        for ( var i = 0; i < 5; i++ ) {
            setTimeout( function () {
                jCanvas.css( 'padding-top', Math.floor( jHeader.height() - 1 ) );
            }, 60 * i );
        }
    }
};

specific.productlist = {

    inputTarget: null,
    submitTimeout: null,
    submitTimeoutTime: 10,

    filter: function () {
        jQuery( '.js-e-productlist-filters' ).find( 'form' ).on( 'change', ':checkbox, :radio', function () {
            clearTimeout( specific.productlist.submitTimeout );
            if ( specific.productlist.inputTarget !== this ) {
                specific.productlist.inputTarget = this;
                specific.productlist.submitTimeout = setTimeout( function () {
                    specific.productlist.inputTarget.form.submit();
                }, specific.productlist.submitTimeoutTime );
            }
        } );
    },
    filterCollapse: function () {
        jQuery( '.js-expand-filters' ).on( 'click', function ( event ) {
            event.preventDefault();
            jQuery( this ).toggleClass( 'selected' );
            jQuery( this ).closest( '.card' ).find( '.card-block' ).toggleClass( 'in' );
        } );
    },
    init: function () {
        if ( jQuery( '.js-e-productlist-filters' ).length === 1 ) {
            specific.productlist.filter();
            specific.productlist.filterCollapse();
        }
    }
};

specific.popupBox = {
    getUrlParameter: function getUrlParameter( sParam ) {
        var sPageURL = window.location.search.substring( 1 ),
            sURLVariables = sPageURL.split( '&' ),
            sParameterName,
            i;

        for ( i = 0; i < sURLVariables.length; i++ ) {
            sParameterName = sURLVariables[ i ].split( '=' );

            if ( sParameterName[ 0 ] === sParam ) {
                return sParameterName[ 1 ] === undefined ? true : decodeURIComponent( sParameterName[ 1 ] );
            }
        }
    },
    trigger: function () {
        if ( jQuery.cookie( jQuery( '.specific-modal' ).data( 'modal-cookie-name' ) ) === undefined ) {
            if ( jQuery( '.specific-modal' ).data( 'modal-for-vets' ).toLowerCase() === 'false' ) {
                if ( jQuery( '.specific-modal' ).data( 'modal-on-load' ).toLowerCase() === 'true' ) {
                    if ( jQuery.cookie( jQuery( '.specific-modal' ).data( 'modal-cookie-name' ) ) === undefined ) {
                        jQuery( '.specific-modal' ).modal();
                    }
                }
                else {
                    jQuery( window ).scroll( function () {
                        if ( ( jQuery( window ).scrollTop() > jQuery( 'body' ).height() / 3 ) && jQuery.cookie( jQuery( '.specific-modal' ).data( 'modal-cookie-name' ) ) === undefined ) {
                            jQuery( '.specific-modal' ).modal();
                        }
                    } );
                }
            }
            else {
                if ( specific.popupBox.getUrlParameter( 'vet' ) !== undefined && specific.popupBox.getUrlParameter( 'vet' ).toLowerCase() === 'true' ) {
                    setTimeout( function () {
                        jQuery( '.specific-modal' ).modal();
                    }, 500 );
                }
            }
        }
    },
    saveCookie: function () {
        var expireAmount = 7;
        jQuery( '.specific-modal .modal-content' ).on( 'click', 'a', function () {
            expireAmount = 365;
            jQuery( '.specific-modal' ).modal( 'hide' );
        } );
        jQuery( '.specific-modal' ).on( 'hide.bs.modal', function () {
            jQuery.cookie( jQuery( this ).data( 'modal-cookie-name' ), 'Closed', {
                path: '/',
                expires: expireAmount
            } );
        } );
    },
    dismiss: function () {
        jQuery( '.specific-modal' ).on( 'shown.bs.modal', function () {
            jQuery( '.specific-modal' ).on( 'click', function () {
                jQuery( '.specific-modal' ).modal( 'hide' );
            } );
            jQuery( document ).keydown( function () {
                if ( event.keyCode === 27 ) {
                    jQuery( '.specific-modal' ).modal( 'hide' );
                }
            } );
        } );
        jQuery( '.specific-modal .modal-content' ).on( 'click', function ( e ) {
            e.stopPropagation();
        } );
    },
    init: function () {
        if ( jQuery( '.specific-modal' ).length > 0 ) {
            specific.popupBox.trigger();
            specific.popupBox.saveCookie();
            specific.popupBox.dismiss();
        }
    }
};

specific.sharePage = {
    popup: function ( jThis, intWidth, intHeight, blnResize ) {
        // Set values for window
        intWidth = intWidth || '500';
        intHeight = intHeight || '400';
        var strResize = ( blnResize ? 'yes' : 'no' );

        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var systemZoom = width / window.screen.availWidth;
        var left = ( width - intWidth ) / 2 / systemZoom + dualScreenLeft
        var top = ( height - intHeight ) / 2 / systemZoom + dualScreenTop

        // Set title and open popup with focus on it
        var strTitle = ( ( typeof jQuery( jThis ).attr( 'title' ) !== 'undefined' ) ? jQuery( jThis ).attr( 'title' ) : 'Social Share' ),
            strParam = 'width=' + intWidth / systemZoom + ',height=' + intHeight / systemZoom + ',resizable=' + strResize + ', top=' + top + ', left=' + left,
            objWindow = window.open( jQuery( jThis ).attr( 'href' ), strTitle, strParam ).focus();
    },
    bindEvent: function () {
        jQuery( '.js-specific-share' ).on( 'click', '.js-specific-share-link', function ( e ) {
            e.preventDefault();
            specific.sharePage.popup( this );
        } );
        jQuery( '.js-specific-share-mobile' ).on( 'click', function ( e ) {
            e.preventDefault();
            jQuery( '.js-specific-share' ).toggleClass( 'specific-share-mobile-open' );
        } );
    },
    init: function () {
        specific.sharePage.bindEvent();
    }
};

specific.disclaimerPopup = {
    trigger: function () {
        if ( jQuery.cookie( 'DisclaimerPopup' ) === undefined ) {
            jQuery( '.specific-modal-disclaimer' ).modal();
        }
    },
    saveCookie: function () {
        var expireAmount = 14;
        jQuery( '.specific-modal-disclaimer' ).on( 'hide.bs.modal', function () {
            jQuery.cookie( 'DisclaimerPopup', 'Closed', {
                path: '/',
                expires: expireAmount
            } );
        } );
    },
    dismiss: function () {
        jQuery( '.specific-modal-disclaimer' ).on( 'shown.bs.modal', function () {
            jQuery( document ).keydown( function () {
                if ( event.keyCode === 27 ) {
                    jQuery( '.specific-modal-disclaimer' ).modal( 'hide' );
                }
            } );
        } );
    },
    init: function () {
        if ( jQuery( '.specific-modal-disclaimer' ).length > 0 ) {
            specific.disclaimerPopup.trigger();
            specific.disclaimerPopup.saveCookie();
            //specific.disclaimerPopup.dismiss();
        }
    }
};
